import {
  CardContent as MuiCardContent,
  type CardContentProps as MuiCardContentProps
} from '@mui/material';

export type CardContentProps = MuiCardContentProps;

export const CardContent = (props: Readonly<CardContentProps>) => <MuiCardContent {...props} />;
